var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 151,
    height: 31,
    viewBox: "0 0 151 31",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.6601 2.8291V24.4989H13.7543V15.1688H4.9058V24.4989H0V2.8291H4.9058V11.0155H13.7543V2.8291H18.6601Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M39.8182 16.4328C39.8182 21.4289 36.056 24.8901 30.8192 24.8901C25.5522 24.8901 21.8202 21.4289 21.8202 16.4328C21.8202 11.4668 25.5522 7.97559 30.8192 7.97559C36.056 7.97559 39.8182 11.4668 39.8182 16.4328ZM34.9726 16.4328C34.9726 13.0018 33.4978 11.7678 30.8192 11.7678C28.1104 11.7678 26.6658 13.0018 26.6658 16.4328C26.6658 19.894 28.1104 21.0978 30.8192 21.0978C33.4978 21.0978 34.9726 19.894 34.9726 16.4328Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M50.0212 20.7061V24.4984H49.2687C45.0552 24.4984 42.6173 22.3013 42.6173 18.5392V0.240234H47.2823V18.3887C47.2823 20.1945 47.9144 20.7061 49.5095 20.7061H50.0212Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M88.816 8.36685V22.5124C88.816 27.9599 86.1976 30.9997 79.7569 30.9997C74.9413 30.9997 72.7744 28.7425 71.6307 25.5221H76.1151C76.5967 26.8464 77.8006 27.2978 79.817 27.2978C82.917 27.2978 84.151 26.5454 84.151 23.0541V21.7299C83.3083 23.0842 82.0743 23.9571 79.3054 23.9571C75.1821 23.9571 71.3297 20.6464 71.3297 16.0717C71.3297 11.3765 74.9112 7.97559 79.3054 7.97559C81.9539 7.97559 83.3986 9.20956 84.151 10.4736V8.36685H88.816ZM84.151 14.8076C83.4588 12.7008 82.6763 11.7377 79.8772 11.7377C77.5899 11.7377 76.1753 13.0319 76.1753 16.0717C76.1753 19.4726 77.5598 20.4959 79.9073 20.4959C82.917 20.4959 83.6694 19.4726 84.151 17.3357V14.8076Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M103.503 8.30665V12.6406C103.022 12.4299 102.3 12.3095 101.397 12.3095C98.7481 12.3095 96.9724 13.5736 96.9724 16.9746V24.4988H92.3074V8.36685H96.9724V10.7144C97.785 9.02898 99.5005 7.97559 101.668 7.97559C102.36 7.97559 103.052 8.09598 103.503 8.30665Z",
    fill: "white"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M121.863 20.7066V24.4988H121.17C118.522 24.4988 117.559 23.8066 116.866 22.5425C116.144 23.927 113.917 24.8901 111.298 24.8901C107.988 24.8901 104.767 23.2347 104.767 19.6231C104.767 16.0717 108.469 14.5367 111.931 14.5367C113.182 14.5144 114.421 14.7931 115.542 15.3493V14.1455C115.542 12.2794 114.94 11.527 112.683 11.527C111.118 11.527 110.305 11.7678 109.914 12.9416H105.369C106.513 9.36004 109.192 7.97559 112.653 7.97559C117.529 7.97559 120.207 10.2931 120.207 14.326V19.3522C120.207 20.4056 120.689 20.7066 121.471 20.7066H121.863ZM115.542 18.359C114.73 17.7872 113.977 17.4561 112.081 17.4561C110.155 17.4561 109.553 18.028 109.553 19.4425C109.553 20.7668 110.155 21.3386 111.9 21.3386C113.706 21.3386 114.669 21.0979 115.542 19.9241V18.359Z",
    fill: "white"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M135.286 0.39142V4.15354C134.455 3.91217 133.593 3.79056 132.728 3.79237C131.313 3.79237 130.47 4.4545 130.47 6.17003V8.36711H134.985V12.1593H130.47V24.4991H125.805V12.1593H122.615V8.36711H125.805V6.13993C125.805 2.58849 128.574 0.000158484 131.975 0.000158484C133.091 -0.00521725 134.202 0.126184 135.286 0.39142Z",
    fill: "white"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M69.1328 15.9151C69.1328 20.7404 65.4382 24.0832 60.2967 24.0832C55.1243 24.0832 51.4592 20.7404 51.4592 15.9151C51.4592 11.1189 55.1243 7.74707 60.2967 7.74707C65.4396 7.74852 69.1328 11.1189 69.1328 15.9151Z",
    fill: "#222222",
    stroke: "url(#paint0_linear_1926_89082)",
    strokeMiterlimit: 10,
    strokeLinecap: "square"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M61.7864 21.1165C64.2093 21.1164 66.5736 20.3843 68.5594 19.0192C67.3328 22.1149 64.2411 24.0843 60.2967 24.0843C58.3859 24.0843 56.6805 23.6265 55.2898 22.8082C55.7066 22.2821 56.2399 21.8562 56.8491 21.5631C57.4583 21.27 58.1274 21.1172 58.8056 21.1165H61.7864ZM61.7864 18.185H58.8056C57.7077 18.185 56.6235 18.4246 55.6312 18.8866C54.6388 19.3485 53.7631 20.0213 53.0671 20.8563C53.3711 21.2507 53.7136 21.6148 54.0898 21.9434C54.6449 21.2318 55.3588 20.6552 56.1764 20.258C56.9941 19.8609 57.8936 19.6538 58.8056 19.6529H61.7864C64.525 19.6532 67.1529 18.5903 69.0988 16.6952C69.121 16.4394 69.1328 16.1807 69.1328 15.9177C69.1331 15.4569 69.0975 14.9968 69.0264 14.5413C68.1995 15.6694 67.1118 16.588 65.853 17.2215C64.5943 17.855 63.2004 18.1852 61.7864 18.185ZM61.7864 10.857C62.1814 10.8566 62.5601 10.7021 62.8393 10.4274C63.1186 10.1528 63.2757 9.78037 63.2761 9.39194V8.16383C62.3083 7.88357 61.3041 7.74354 60.2953 7.74816C56.5164 7.74816 53.5445 9.54891 52.2159 12.3874C54.2621 11.3833 56.5173 10.8599 58.8041 10.8584L61.7864 10.857ZM61.7864 13.7885C62.9186 13.7867 64.0079 13.363 64.835 12.6027C65.6621 11.8424 66.1655 10.8021 66.2436 9.69134C65.7865 9.32611 65.2911 9.0099 64.7658 8.74809V9.39194C64.7646 10.1691 64.4501 10.914 63.8914 11.4636C63.3326 12.0131 62.5751 12.3223 61.7849 12.3234H58.8056C56.2453 12.3224 53.739 13.0481 51.5878 14.4134C51.5016 14.9099 51.4586 15.4126 51.4592 15.9162C51.4592 16.0427 51.4592 16.1662 51.4681 16.2912C53.5583 14.6697 56.1434 13.7885 58.8056 13.7899L61.7864 13.7885ZM58.8056 16.72H61.7864C63.1805 16.7189 64.5462 16.3329 65.7282 15.606C66.9102 14.8791 67.8609 13.8405 68.4722 12.6083C68.2228 12.0301 67.9011 11.4848 67.5145 10.9849C67.1612 12.2119 66.4109 13.2924 65.3774 14.0626C64.3438 14.8328 63.0832 15.2509 61.7864 15.2535H58.8056C56.1703 15.2551 53.6344 16.2423 51.7119 18.0149C51.8396 18.5431 52.0223 19.057 52.2573 19.5483C53.0908 18.6574 54.103 17.9461 55.2301 17.4593C56.3572 16.9725 57.5746 16.7208 58.8056 16.72Z",
    fill: "url(#paint1_radial_1926_89082)"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M69.1328 15.9151C69.1328 20.7404 65.4382 24.0832 60.2967 24.0832C55.1243 24.0832 51.4592 20.7404 51.4592 15.9151C51.4592 11.1189 55.1243 7.74707 60.2967 7.74707C65.4396 7.74852 69.1328 11.1189 69.1328 15.9151Z",
    stroke: "url(#paint2_linear_1926_89082)",
    strokeMiterlimit: 10,
    strokeLinecap: "square"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M143.877 14.6323C146.97 15.2374 150.635 16.1754 150.635 19.776C150.635 23.6188 146.85 24.9804 143.035 24.9804C138.56 24.9804 136.127 23.2254 135.286 19.6248H139.701C140.002 20.7745 140.512 21.41 142.885 21.41C144.928 21.41 145.859 21.0771 145.859 20.0786C145.859 18.9288 145.408 18.717 142.825 18.2027C139.881 17.6278 135.856 16.6293 135.856 12.9378C135.856 9.51872 139.221 7.97559 143.126 7.97559C147.151 7.97559 149.734 9.73053 150.485 12.9983H146.069C145.649 11.9696 145.168 11.546 143.276 11.546C141.263 11.546 140.572 11.9696 140.572 12.9076C140.572 13.785 141.233 14.1179 143.877 14.6323Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1926_89082",
    x1: 51.0898,
    y1: 15.9166,
    x2: 69.5022,
    y2: 15.9166,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFB6D5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#FFE3C0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#C7FBDB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#C7CDF4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#FFBCD4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#FFE0C3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#B0F1D4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#C9CEEC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "#FFC1DA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BDFFE3"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint1_radial_1926_89082",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(60.2967 15.9162) scale(8.57593 8.43404)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFB6D5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#FFE3C0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#C7FBDB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#C7CDF4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#FFBCD4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#FFE0C3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#B0F1D4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#C9CEEC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "#FFC1DA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BDFFE3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_1926_89082",
    x1: 51.0898,
    y1: 15.9166,
    x2: 69.5022,
    y2: 15.9166,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFB6D5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#FFE3C0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#C7FBDB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#C7CDF4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#FFBCD4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#FFE0C3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#B0F1D4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#C9CEEC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "#FFC1DA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BDFFE3"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.ce96e93398797fc6309f73e46869d300.svg";
export { ForwardRef as ReactComponent };